import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {Component, forwardRef, Injector, Input, OnChanges, SimpleChanges} from "@angular/core";
import {AbstractColumnComponent} from "../../../framework/entity/grid/abstract-column.component";

@Component({
    selector: "wbo-sellable-size-column",
    templateUrl: "./sellable-size-column.component.html",
    providers: [{
        provide: ColumnComponent,
        useExisting: forwardRef(() => SellableSizeColumnComponent),
        multi: true
    }]
})
export class SellableSizeColumnComponent extends AbstractColumnComponent implements OnChanges {
    @Input() sizeGroupIdField: string;
    valueField: string;
    label: string;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.valueField = this.field + "." + "id";
        this.label = this.field + ".label";
    }

}
